import React from "react";
import PropTypes from 'prop-types';

import NumberFormat from 'react-number-format';  // See : https://www.npmjs.com/package/react-number-format

import { TextField } from "@mui/material";

const Prix = ({ value, editable, onChange, ...otherProps }) => {

    return (
        <NumberFormat
            value={value}
            displayType={editable ? '' : 'text'}
            decimalScale={2}
            fixedDecimalScale={true}
            decimalSeparator={','}
            thousandSeparator={' '}
            suffix={' €'}
            customInput={editable ? TextField : null}
            inputProps={{ sx: { textAlign: 'right' } }}
            {...otherProps}  // ie : allowNegative (default = true)
            onValueChange={values => { // ie : { formattedValue: "1 000,99 €", value: "1000.99", floatValue: 1000.99 }
                onChange(values.floatValue);
            }}
        />
    );
}



Prix.propTypes = {
    value: PropTypes.number.isRequired,
    editable: PropTypes.bool,
    onChange: PropTypes.func,
};

Prix.defaultProps = {
    editable: false,
}

export default Prix;